import React from "react";
import { useNavigate } from "react-router-dom";
import Title from "../components/Title";
import DashboardLayout from "../layouts/Dashboard";

const SuccessPage = () => {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <div className="flex flex-col items-center justify-center pt-24 bg-gradient-to-b from-blue-50 to-indigo-100 py-16 rounded-lg shadow-xl">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-16 h-16 text-green-500 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
        <Title
          title="Payment Successful"
          className="text-cf--primary text-3xl font-semibold"
        />
        <p className="mt-4 text-lg text-center text-gray-800">
          Your payment was processed successfully! 🎉
        </p>
        <p className="mt-2 text-sm text-gray-600">
          Your balance has been updated.
        </p>
        <button
          className="mt-6 px-6 py-3 bg-cf--primary text-white rounded-full hover:bg-cf--secondary transition-all ease-in-out duration-300 transform hover:scale-105"
          onClick={() => navigate("/dashboard")}
        >
          Go to Dashboard
        </button>
      </div>
    </DashboardLayout>
  );
};

export default SuccessPage;
